import { Switch as HeadlessSwitch } from "@headlessui/react";

interface ToggleProps {
  text?: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

export const FormToggle = ({
  text,
  checked,
  onChange,
  className
}: ToggleProps) => (
  <HeadlessSwitch.Group
    as="div"
    className={`flex cursor-pointer items-center ${className}`}
  >
    <HeadlessSwitch
      checked={checked}
      onChange={(value) => onChange?.(value)}
      className={`    ${checked ? "bg-primary" : "bg-black-light"}
      relative
      inline-flex
      h-5
      w-8
      cursor-pointer
      items-center
      rounded-full
      transition-colors
      duration-200
      ease-in-out`}
      as="div"
    >
      <span
        className={`    ${checked ? "translate-x-4" : "translate-x-1"}
    inline-block
    h-3
    w-3
    rounded-full
    bg-white
    transition-all
    duration-200
    ease-in-out`}
      />
    </HeadlessSwitch>
    <HeadlessSwitch.Label className="mb-0 ml-2 cursor-pointer text-base text-black-light">
      {text}
    </HeadlessSwitch.Label>
  </HeadlessSwitch.Group>
);
